<app-modal [modalConfig]="modalConfig">
  <form [formGroup]="reportGroupForm" (ngSubmit)="onSubmit()">
    <div class="create-report-group">
      <div class="input-container">
        <label>
          Nombre
            <span class="mandatory">*</span>
        </label>
        <input class="form-input" formControlName="name" type="" [ngClass]="{'error':hasErrors('name')}">
      </div>
      <div class="input-container">
        <label>
          Descripción
            <span class="mandatory">*</span>
        </label>
        <textarea placeholder="Escribe Max 255 caracteres" class="form-input" formControlName="description"
        rows="5" [ngClass]="{'error':hasErrors('description')}" maxlength="255">
        </textarea>
      </div>
      <button class="btn-submit" [disabled]="isLoading">{{ reportGroup ? "Guardar" : "Crear" }}</button>
    </div>
    <ngx-loading [show]="isLoading"></ngx-loading>
  </form>
</app-modal>